import { render, staticRenderFns } from "./BaseRankingBarChart.vue?vue&type=template&id=822116a2"
import script from "./BaseRankingBarChart.vue?vue&type=script&lang=js"
export * from "./BaseRankingBarChart.vue?vue&type=script&lang=js"
import style0 from "./BaseRankingBarChart.vue?vue&type=style&index=0&id=822116a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports